import React from "react";
import ControlLibraryTable from "./ControlLibraryTable";
import ErrorAlert from "../../../components/UI/ErrorAlert/ErrorAlert";
import Loader from "../../../components/Common/Loader";
import { useSelector } from "react-redux";

const ControlLibraryBody = ({
  populateLibraryList,
  setDrawerVisible,
  handleDrawerOpen,
  ...rest
}) => {
  const { preassementError } = useSelector((state) => state.preAssessment);
  const { libraryList, loading, libraryListingError } = useSelector(
    (state) => state.controlLibrary
  );
  return (
    <div className="list-body">
      {loading ? (
        <Loader />
      ) : (
        <>
          {!loading && libraryList.length == 0 ? (
            <ErrorAlert
              errorData={libraryListingError || preassementError}
              message={
                libraryList.length == 0 &&
                "No links are added in this organization."
              }
            />
          ) : (
            <ControlLibraryTable
              populateLibraryList={populateLibraryList}
              setDrawerVisible={setDrawerVisible}
              handleDrawerOpen={handleDrawerOpen}
              {...rest}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ControlLibraryBody;
